Object.assign(String.prototype, {
  capitalize() {
    const lower = this.toLowerCase();
    return this.charAt(0).toUpperCase() + lower.slice(1);
  },
});
